import FlexPane from './_flex-pane.js'
import Dropdown from './_dropdown.js'

export default {
  name: 'TeaserOptions',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 16px',
          maxWidth: '100%',
        },
      },
    },
    dropdown: {
      configSet: Dropdown,
      configValues: {
        style: {
          rootContainer: {
            width: '100%',
          },
        },
      },
    },
    teaserTypesOrder: [
      'LOW',
      'MEDIUM',
      'HIGH',
    ],
  },
  meta: {
    extendable: false,
  },
}
